<div class="document-wrapper" [ngStyle]="{'height': scrHeight}">
  <div class="p-3 bg-light">
  <div class="bg-white border rounded-3 p-3 shadow-sm">
    <!-- Add Collection / Add Sub Collection Modal -->
    <div class="modal-backdrop show" *ngIf="showAddModal" (click)="cancelAddCollection()"></div>
    <div class="modal d-flex show" *ngIf="showAddModal" (click)="$event.stopPropagation()">
      <div class="modal-dialog modal-dialog-centered modal-dialog-custom m-auto">
        <div class="modal-content">
          <div class="modal-header border-0">
            <div>
              <h5 class="modal-title fs-6 fw-bold m-0">
                {{ selectedTabIndex === 0 ? 'Add New Collection' : 'Add Sub-Collections' }}
              </h5>
            </div>
            <button type="button" class="close-btn" (click)="cancelAddCollection()" title="Cancel">✕</button>
          </div>
          
          <hr class="divider" />

          <div class="modal-body">
            <!-- Tabs -->
            <div class="tab-header">
              <button [class.active]="selectedTabIndex === 0" (click)="onTabChange(0)">Add Collection</button>
              <button [class.active]="selectedTabIndex === 1" (click)="onTabChange(1)">Add Sub Collection</button>
            </div>

            <!-- Add Collection Tab -->
            <div *ngIf="selectedTabIndex === 0">
              <!-- Collection Name -->
              <div class="form-group">
                <label>Collection Name <span class="required">*</span></label>
                <input class="expand-input" type="text" [(ngModel)]="newCollectionName" placeholder="Enter collection name"
                  (input)="validateCollectionName(); validateForm()" />
                <span *ngIf="collectionExists" class="error-text collection-error">
                  Collection already exists!
                </span>
              </div>

              <!-- Sub Collections -->
              <label class="sub-title">Sub Collections</label>

              <ng-container *ngFor="let sub of subCollectionArray; let i = index; trackBy: trackByIndex">
                <div class="form-group sub-collection">
                  <div class="input-row">
                    <input class="expand-input" type="text" [(ngModel)]="subCollectionArray[i].value"
                      placeholder="Enter sub collection name" (input)="validateSubCollectionName(i); validateForm()" />
                    <span class="remove-icon" (click)="removeSubCollectionField(i)" title="Remove">✕</span>
                  </div>

                  <!-- Error under the input row -->
                  <span *ngIf="subCollectionExists[i]" class="error-text">
                    Sub-collection already exists!
                  </span>
                </div>
              </ng-container>

              <a class="add-link" (click)="addSubCollectionField()">+ Add Another Sub-Collection</a>
            </div>

            <!-- Add Sub-Collection Tab -->
            <div *ngIf="selectedTabIndex === 1">
              <!-- Collection Search/Selection -->
              <div class="form-group">
                <label>Select Existing Collection <span class="required">*</span></label>
                <div class="collection-search-wrapper">
                  <select class="form-select" [(ngModel)]="selectedCollectionForAddSub" (change)="validateForm()">
                    <option [ngValue]="null">-- Select a Collection --</option>
                    <option *ngFor="let col of collections" [ngValue]="col">{{ col.name }}</option>
                  </select>
                </div>
              </div>

              <div *ngIf="selectedCollectionForAddSub"> 
                <label class="sub-title">Add New Sub-Collections <span class="required">*</span></label>

                <ng-container *ngFor="let sub of newSubCollections; let i = index; trackBy: trackByIndex">
                  <div class="form-group sub-collection">
                    <div class="input-row">
                      <input class="expand-input" type="text" [(ngModel)]="newSubCollections[i]" placeholder="Enter new sub-collection name"
                        (input)="validateSubCollectionName(i); validateForm()" />

                      <span *ngIf="i > 0" class="remove-icon" (click)="removeNewSubCollectionField(i)" title="Remove">✕</span>
                    </div>

                    <span *ngIf="subCollectionExists[i]" class="error-text">
                      Sub-collection already exists!
                    </span>
                  </div>
                </ng-container>

                <a class="add-link" (click)="addNewSubCollectionField()">+ Add Another Sub-Collection</a>
              </div>
            </div>
          </div>

          <hr class="divider" />

          <div class="modal-footer border-0">
            <button type="button" class="btn btn-outline-secondary btn-cancel" (click)="cancelAddCollection()" [disabled]="isAddingCollection || isAddingSubCollection">Cancel</button>
            <button type="button" class="btn btn-danger" [disabled]="!isFormValid || isAddingCollection || isAddingSubCollection" (click)="saveSubCollection(selectedTabIndex)">
              <span *ngIf="!isAddingCollection && !isAddingSubCollection">Save</span>
              <span *ngIf="isAddingCollection || isAddingSubCollection"><i class="material-icons spinner-icon">hourglass_empty</i> Saving...</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Edit Collection Modal -->
    <div class="modal-backdrop show" *ngIf="showEditModal" (click)="cancelEditCollection()"></div>
    <div class="modal d-flex show" *ngIf="showEditModal" (click)="$event.stopPropagation()">
      <div class="modal-dialog modal-dialog-centered modal-dialog-custom m-auto">
        <div class="modal-content">
          <div class="modal-header border-0">
            <div>
              <h5 class="modal-title fs-6 fw-bold m-0 d-flex align-items-center gap-2 text-danger">
                <mat-icon>edit</mat-icon> Edit Collection
              </h5>
              <p class="text-muted small mb-0 mt-1">Update the name for this collection.</p>
            </div>
            <button type="button" class="close-btn" (click)="cancelEditCollection()" title="Cancel">✕</button>
          </div>
          
          <hr class="divider" />

          <div class="modal-body">
            <div class="form-group">
              <label>Collection Name <span class="required">*</span></label>
              <input class="expand-input" type="text" [(ngModel)]="editCollectionName" placeholder="Enter Collection Name" (keyup.enter)="submitEditCollection()" (input)="checkEditCollectionDuplicate()" />
              <span *ngIf="editCollectionNameError" class="error-text">{{editCollectionNameError}}</span>
            </div>
          </div>

          <hr class="divider" />

          <div class="modal-footer border-0">
            <button type="button" class="btn btn-outline-secondary btn-cancel" (click)="cancelEditCollection()" [disabled]="isAddingCollection">Cancel</button>
            <button type="button" class="btn btn-danger" (click)="submitEditCollection()" [disabled]="!editCollectionName.trim() || editCollectionNameError || isAddingCollection">
              <span *ngIf="!isAddingCollection">Save Changes</span>
              <span *ngIf="isAddingCollection"><i class="material-icons spinner-icon">hourglass_empty</i> Saving...</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Delete Confirmation Modal -->
    <div class="modal-backdrop show" *ngIf="showDeleteConfirmModal" (click)="cancelDelete()"></div>
    <div class="modal d-flex show" *ngIf="showDeleteConfirmModal" (click)="$event.stopPropagation()">
      <div class="modal-dialog modal-dialog-centered modal-dialog-custom m-auto">
        <div class="modal-content">
          <div class="modal-header border-0">
            <h5 class="modal-title fs-6 fw-bold m-0 d-flex align-items-center gap-2 text-danger">
              <mat-icon>error_outline</mat-icon> Confirm Archive
            </h5>
            <button type="button" class="close-btn" (click)="cancelDelete()" title="Cancel">✕</button>
          </div>
          
          <hr class="divider" />

          <div class="modal-body">
            <p class="text-muted small mb-3">Are you sure you want to archive "<strong>{{deleteConfirmTitle}}</strong>"?</p>
            <div class="delete-info-box">
              <div class="small text-muted">Note: {{ deleteType === 'collection' ? 'Collection' : 'Sub-collection' }} will be moved to Archived List</div>
              <div class="small text-muted">You can restore this {{ deleteType === 'collection' ? 'collection' : 'sub-collection' }} from the Archived List if needed.</div>
            </div>
          </div>

          <hr class="divider" />

          <div class="modal-footer border-0">
            <button type="button" class="btn btn-outline-secondary btn-cancel" (click)="cancelDelete()">Cancel</button>
            <button type="button" class="btn btn-danger d-inline-flex align-items-center gap-1" (click)="confirmDelete()"><mat-icon>archive</mat-icon> Archive</button>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex flex-column flex-sm-row align-items-start justify-content-between mb-3">
      <div>
        <label class="modal-title d-block mb-1">Manage Collections</label>
        <p class="text-muted small mb-0 d-none d-sm-block">View and manage all your collections and sub‑collections.</p>
      </div>
      <div class="mt-2 mt-sm-0">
        <button class="btn btn-danger w-100 w-sm-auto" (click)="openAddDialog()"><i class="material-icons">add</i>Add Collection</button>
      </div>
    </div>

    <div class="stats-grid">
      <div class="stat-panel">
        <div class="stat-icon red-tile"><mat-icon>folder_open</mat-icon></div>
        <div>
          <div class="stat-number">{{ getActiveCollectionsCount() }}</div>
          <div class="stat-title">Active Collections</div>
        </div>
      </div>
      <div class="stat-panel">
        <div class="stat-icon blue-tile"><mat-icon>layers</mat-icon></div>
        <div>
          <div class="stat-number">{{ getActiveSubCollectionsCount() }}</div>
          <div class="stat-title">Active Sub-Collections</div>
        </div>
      </div>
      <div class="stat-panel">
        <div class="stat-icon slate-tile"><mat-icon>archive</mat-icon></div>
        <div>
          <div class="stat-number">{{ getDeletedCollectionsCount() }}</div>
          <div class="stat-title">Archived Collections</div>
        </div>
      </div>
      <div class="stat-panel">
        <div class="stat-icon amber-tile"><mat-icon>inventory_2</mat-icon></div>
        <div>
          <div class="stat-number">{{ getDeletedSubCollectionsCount() }}</div>
          <div class="stat-title">Archived Sub-Collections</div>
        </div>
      </div>
    </div>

    <div class="toolbar-row">
      <div class="list-toggle-group">
        <button type="button" class="list-toggle" [class.active]="!showDeleted" (click)="showDeleted=false">
          <span>Active List</span>
          <span class="toggle-badge">{{getActiveCollectionsCount()}}</span>
        </button>
        <button type="button" class="list-toggle" [class.active]="showDeleted" (click)="toggleDeleted()">
          <span>Archived List</span>
          <span class="toggle-badge">{{getDeletedCollectionsCount()}}</span>
        </button>
      </div>
      <div class="search-container toolbar-search">
        <mat-icon class="search-icon">search</mat-icon>
        <input type="text" class="search-input" [placeholder]="showDeleted ? 'Search archived collections...' : 'Search active collections...'" [(ngModel)]="searchText" (input)="setSearch(searchText)" />
      </div>
    </div>
  </div>
  </div>

  <div class="p-3 bg-light" *ngIf="!showDeleted">
    <div class="row g-3">
      <div class="col-12" *ngFor="let col of filteredCollections()">
        <div class="card border">
          <div class="card-header bg-white d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center py-3 gap-2 cursor-pointer" (click)="toggleExpand(col)">
            <div class="d-flex align-items-center gap-2 gap-md-3 overflow-hidden">
              <mat-icon class="transition-transform" [class.rotate-180]="col.expanded">expand_more</mat-icon>
              <div class="overflow-hidden">
                <div class="d-flex flex-wrap align-items-center gap-1"><span class="text-truncate">{{col.name}}</span> <span class="badge bg-success-subtle text-success">{{col.subCollections?.length || 0}} Active</span> <span class="badge bg-danger-subtle text-danger">{{col.deletedSubCollections?.length || 0}} Archived</span></div>
                <div class="text-muted small">Created at {{(col.createdAt| date:'MM/dd/yyyy hh:mm a')}}</div>
              </div>
            </div>
            <div class="d-flex flex-wrap gap-2 align-self-md-center">
              <button class="btn btn-sm btn-outline-secondary d-inline-flex align-items-center gap-1" (click)="editCollection(col); $event.stopPropagation()"><mat-icon>edit</mat-icon> <span class="d-none d-sm-inline">Edit</span></button>
              <button class="btn btn-sm btn-outline-danger d-inline-flex align-items-center gap-1" (click)="deleteCollection(col); $event.stopPropagation()"><mat-icon>archive</mat-icon> <span class="d-none d-sm-inline">Archive</span></button>
            </div>
          </div>

          <div class="card-body bg-light" *ngIf="col.expanded">
            <div class="d-flex flex-column flex-sm-row align-items-start align-items-sm-center justify-content-between gap-2 mb-3">
              <div class="d-inline-flex align-items-center gap-1 text-dark-primary"><mat-icon class="text-success">check_circle</mat-icon> Active Sub-Collections ({{col.subCollections.length}})</div>
              <button class="btn btn-danger" (click)="addSubCollection(col)"><i class="material-icons">add</i>Add Sub-Collection</button>
            </div>
            <div class="d-flex flex-wrap gap-3">
              <div class="sub-card bg-white border rounded-3 p-3 d-inline-block" *ngFor="let s of filteredSubCollections(col)">
                <div class="d-inline-flex align-items-start gap-3">
                  <div class="pt-1">
                    <div><span>{{s.name}}</span></div>
                    <div class="text-muted small">Created at {{(s.updated | date:'MM/dd/yyyy hh:mm a')}}</div>
                  </div>
                  <div class="sub-card-icons d-flex align-items-start gap-2 pt-1">
                    <span class="action-icon" title="Edit" (click)="editSubCollection(col, s)"><mat-icon>edit</mat-icon></span>
                    <span class="action-icon" title="Archive" (click)="deleteSubCollection(col, s)"><mat-icon>archive</mat-icon></span>
                  </div>
                </div>
              </div>
            </div>

            <hr class="my-3 mx-n3" *ngIf="(col.deletedSubCollections?.length || 0) > 0" />

            <div *ngIf="(col.deletedSubCollections?.length || 0) > 0">
              <div class="mb-3 d-inline-flex align-items-center gap-1 text-dark-primary"><mat-icon class="text-danger">inventory_2</mat-icon> Archived Sub-Collections ({{col.deletedSubCollections.length}})</div>
              <div class="d-flex flex-wrap gap-3">
                <div class="sub-card border rounded-3 p-3 d-inline-block sub-card-deleted" *ngFor="let ds of filteredDeletedSubCollections(col)">
                  <div class="d-inline-flex align-items-start gap-3">
                    <div class="pt-1">
                      <div><span>{{ds.name}}</span></div>
                      <div class="text-muted small">Archived At {{(ds.deletedAt | date:'MM/dd/yyyy hh:mm a')}}</div>
                    </div>
                    <div class="sub-card-icons d-flex align-items-start gap-2 pt-1">
                      <span class="action-icon" title="Restore" (click)="restoreSubCollection(col, ds)"><mat-icon>restore</mat-icon></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Deleted Collections List -->
  <div class="p-3 bg-light" *ngIf="showDeleted">
    <div class="row g-3">
      <div class="col-12" *ngFor="let item of filteredDeletedCollections()">
        <div class="card border">
          <div class="card-header bg-white d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center py-3 gap-2 cursor-pointer" (click)="toggleExpand(item)">
            <div class="d-flex align-items-center gap-2 gap-md-3 overflow-hidden">
              <mat-icon class="transition-transform" [class.rotate-180]="item.expanded">expand_more</mat-icon>
              <div class="overflow-hidden">
                <div class="d-flex flex-wrap align-items-center gap-1"><span class="text-truncate">{{item.name}}</span> <span class="badge bg-danger-subtle text-danger">Archived At {{(item.deletedAt | date:'MM/dd/yyyy hh:mm a')}}</span></div>
                <div class="text-muted small">Created at {{(item.updated | date:'MM/dd/yyyy hh:mm a')}}</div>
              </div>
            </div>
            <div class="d-flex flex-wrap gap-2 align-self-md-center">
              <button class="btn btn-sm btn-outline-secondary d-inline-flex align-items-center gap-1" (click)="restoreCollection(item); $event.stopPropagation()"><mat-icon>restore</mat-icon> <span class="d-none d-sm-inline">Restore</span></button>
            </div>
          </div>

          <div class="card-body bg-light" *ngIf="item.expanded && (item.deletedSubCollections?.length || 0) > 0">
            <div class="mb-3 d-inline-flex align-items-center gap-1 text-dark-primary"><mat-icon class="text-danger">inventory_2</mat-icon> Archived Sub-Collections ({{item.deletedSubCollections.length}})</div>
            <div class="d-flex flex-wrap gap-3">
              <div class="sub-card border rounded-3 p-3 d-inline-block sub-card-deleted" *ngFor="let ds of item.deletedSubCollections">
                <div class="d-inline-flex align-items-start gap-3">
                  <div class="pt-1">
                    <div><span>{{ds.name}}</span></div>
                    <div class="text-muted small">Archived At {{(ds.deletedAt | date:'MM/dd/yyyy hh:mm a')}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Add Sub-Collection Modal -->
  <div class="modal-backdrop show" *ngIf="showAddSubModal" (click)="cancelAddSubCollection()"></div>
  <div class="modal d-flex show" *ngIf="showAddSubModal" (click)="$event.stopPropagation()">
    <div class="modal-dialog modal-dialog-centered modal-dialog-custom m-auto">
      <div class="modal-content">
        <div class="modal-header border-0 pb-0">
          <label class="modal-title">Add New Sub-Collection</label>
          <button type="button" class="btn-close" (click)="cancelAddSubCollection()"></button>
        </div>
        <div class="modal-body">
          <label class="form-label required-field mb-2">Sub-Collection Name</label>
          <input type="text" class="form-control" [(ngModel)]="newSubName" placeholder="Enter Sub-Collection Name" (keyup.enter)="submitAddSubCollection()" (input)="checkAddSubCollectionDuplicate()" />
          <div class="text-danger small mt-1" *ngIf="subCollectionNameError">{{subCollectionNameError}}</div>
        </div>
        <div class="modal-footer border-0 pt-0">
          <button type="button" class="btn btn-outline-secondary btn-cancel" (click)="cancelAddSubCollection()" [disabled]="isAddingSubCollection">Cancel</button>
          <button type="button" class="btn btn-danger" (click)="submitAddSubCollection()" [disabled]="!newSubName.trim() || subCollectionNameError || isAddingSubCollection">
            <span *ngIf="!isAddingSubCollection">Save</span>
            <span *ngIf="isAddingSubCollection"><i class="material-icons spinner-icon">hourglass_empty</i> Saving...</span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- Edit Sub-Collection Modal -->
  <div class="modal-backdrop show" *ngIf="showEditSubModal" (click)="cancelEditSubCollection()"></div>
  <div class="modal d-flex show" *ngIf="showEditSubModal" (click)="$event.stopPropagation()">
    <div class="modal-dialog modal-dialog-centered modal-dialog-custom m-auto">
      <div class="modal-content">
        <div class="modal-header border-0 pb-0">
          <div>
            <h5 class="modal-title fs-6 fw-bold m-0 d-flex align-items-center gap-2 text-danger">
              <mat-icon>edit</mat-icon> Edit Sub-Collection
            </h5>
            <p class="text-muted small mb-0 mt-1">Update the name for this sub-collection.</p>
          </div>
          
          <button type="button" class="close-btn" (click)="cancelEditSubCollection()" title="Cancel">✕</button>
        </div>
        <hr class="divider" />
        <div class="modal-body">
          <label class="form-label required-field mb-2">Sub-Collection Name</label>
          <input type="text" class="form-control" [(ngModel)]="editSubName" placeholder="Enter Sub-Collection Name" (keyup.enter)="submitEditSubCollection()" (input)="checkEditSubCollectionDuplicate()" />
          <div class="text-danger small mt-1" *ngIf="editSubNameError">{{editSubNameError}}</div>
        </div>
        <hr class="divider" />
        <div class="modal-footer border-0 pt-0">
          <button type="button" class="btn btn-outline-secondary btn-cancel" (click)="cancelEditSubCollection()" [disabled]="isEditingSubCollection">Cancel</button>
          <button type="button" class="btn btn-danger" (click)="submitEditSubCollection()" [disabled]="!editSubName.trim() || editSubNameError || isEditingSubCollection">
            <span *ngIf="!isEditingSubCollection">Save Changes</span>
            <span *ngIf="isEditingSubCollection"><i class="material-icons spinner-icon">hourglass_empty</i> Saving...</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <app-tutorial-video-widget
    screenId="manage-collections"
    title="Manage Collections walkthrough"
    teaserDescription="Watch a quick walkthrough of this screen."
    storageKey="manage-collections-tutorial-seen"
    teaserPosition="bottom-right"
    launcherPosition="bottom-right"
    [autoPlaySequence]="adminTutorialSequence"
    [allowLauncherDismiss]="true">
  </app-tutorial-video-widget>
</div>
